module.exports = "    <div class=\"loadpage\">\r\n      <img src=\"./images/portal/eloan-logo.png\">\r\n    </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.html
// module id = 703
// module chunks = 8